define('bindingHandlers/sortableList',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',
    'util/keyCode'
], function ($, ko, _, keyCode) {
    'use strict';

    /**
     * Binding which makes its direct children DOM elements sortable by dragging them
     *
     * Example:
     * <li data-bind="foreach: panels, sortableList: panels">
     *     <div class="panel-header" data-bind="sortableItem: $data">
     *         <span class="title h4" data-bind="text: heading"></span>
     *     </div>
     * </li>
     *
     * @exports bindingHandlers/sortableList
     */

    ko.bindingHandlers.sortableList = {
        init: function(element, valueAccessor) {
            var list = valueAccessor();
            $(element).sortable({
                update: function(event, ui) {
                    //retrieve our actual data item
                    var item = ui.item.data("sortItem");
                    var dataContent = item;
                    var afterMove;

                    if(_.has(item, 'data')) {
                        dataContent = item.data;
                    }
                    if(_.has(item, 'afterMove')) {
                        afterMove = item.afterMove;
                    }

                    //figure out its new position
                    var position = ko.utils.arrayIndexOf(ui.item.parent().children(), ui.item[0]);
                    //remove the item and add it back in the right spot
                    if (position >= 0) {
                        var tempList = list();
                        _.remove(tempList, function(item) {
                            return ko.unwrap(item.id) === ko.unwrap(dataContent.id);
                        });
                        tempList.splice(position, 0, dataContent);
                        list(tempList);
                    }
                    if (afterMove) {
                        afterMove();
                    }
                }
            });
            $(element).children().bind('keydown', function(event) {
                var target = ko.dataFor(event.target);
                var tempList = list();
                var position = ko.utils.arrayIndexOf(tempList, target);

                if(event.which === keyCode.UP) {        //UP
                    if(position > 0) {
                        _.remove(tempList, function(item) {
                            return ko.unwrap(item.id) === ko.unwrap(target.id);
                        });
                        tempList.splice(position-1, 0, target);
                        list(tempList);
                        _.forEach($(element).children(), function(child) {
                            if(ko.unwrap(ko.dataFor(child).id) === ko.unwrap(target.id)) {
                                $(child).focus();
                            }
                        });
                    }
                } else if(event.which === keyCode.DOWN) { //DOWN
                    if(position >= 0 && position < list().length-1) {
                        _.remove(tempList, function(item) {
                            return ko.unwrap(item.id) === ko.unwrap(target.id);
                        });
                        tempList.splice(position+1, 0, target);
                        list(tempList);
                        _.forEach($(element).children(), function(child) {
                            if(ko.unwrap(ko.dataFor(child).id) === ko.unwrap(target.id)) {
                                $(child).focus();
                            }
                        });
                    }
                } else {
                    return;
                }
                event.preventDefault();
            });
        }
    };
    /**
     * Sortable item binding that is used alongside sortableList.
     * It adds sortItem property onto the element so that sortableList
     * can reference it during sorting.
     *
     * @params valueAccessor The content passed can be individual
     * view-model data object or an object containing data and afterMove method.
     * afterMove method will be invoked once an item has been dragged and dropped
     * into its new position.
     *
     * Example:
     * <div data-bind=" sortableItem: {data: $data, afterMove: methodToBeCalled}"></div>
     *
     */
    ko.bindingHandlers.sortableItem = {
        init: function(element, valueAccessor) {
            var data = valueAccessor();
            $(element).data("sortItem", data);
        }
    };
});

